import { Pipe, PipeTransform } from '@angular/core';
import {MonitoredTrain} from "@/app/features/monitoring/models/monitored-train";

@Pipe({
  name: 'trainUsersCount'
})
export class TrainUsersCountPipe implements PipeTransform {

  transform(train: MonitoredTrain, category: string): number {
    switch (category) {
      case 'logins':
        return train.users.reduce ( (count, user) => count + user.logins, 0 );
      case 'staff':
        return train.users.reduce ( (count, user) => count + user.staffCount, 0 );
      default :
        return 0;
    }
  }
}
